var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2399 3.10156C11.2399 2.68735 11.5757 2.35156 11.9899 2.35156H19.8545C20.821 2.35156 21.6045 3.13506 21.6045 4.10156V19.8965C21.6045 20.863 20.821 21.6465 19.8545 21.6465H11.9899C11.5757 21.6465 11.2399 21.3107 11.2399 20.8965C11.2399 20.4823 11.5757 20.1465 11.9899 20.1465H19.8545C19.9926 20.1465 20.1045 20.0346 20.1045 19.8965V4.10156C20.1045 3.96349 19.9926 3.85156 19.8545 3.85156H11.9899C11.5757 3.85156 11.2399 3.51578 11.2399 3.10156ZM9.91877 7.37294C10.2241 7.09303 10.6985 7.11364 10.9784 7.41896L14.5633 11.3294C14.8142 11.6031 14.8271 12.0192 14.5936 12.3079L11.0087 16.7403C10.7483 17.0624 10.276 17.1123 9.95395 16.8518C9.63189 16.5913 9.58196 16.1191 9.84244 15.797L12.4393 12.5862H3.14551C2.73129 12.5862 2.39551 12.2504 2.39551 11.8362C2.39551 11.422 2.73129 11.0862 3.14551 11.0862H12.3055L9.87275 8.4326C9.59284 8.12727 9.61344 7.65285 9.91877 7.37294Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign_in.11e6af4a0462ec8cf8ff1bfd21c89b42.svg";
export { ForwardRef as ReactComponent };